import { render, staticRenderFns } from "./PdfObseques.vue?vue&type=template&id=7a2eaaaa&scoped=true&"
import script from "./PdfObseques.vue?vue&type=script&lang=js&"
export * from "./PdfObseques.vue?vue&type=script&lang=js&"
import style0 from "./PdfObseques.vue?vue&type=style&index=0&id=7a2eaaaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2eaaaa",
  null
  
)

export default component.exports